
define('template!ordersDetailOrderView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="left">\n  <div class="client-region"></div>\n  <div class="status-region"></div>\n  <div class="history-region"></div>\n</div>\n<div class="right">\n  <div class="comments-region"></div>\n  <div class="phrases-region"></div>\n  <div class="product-region"></div>\n  <div class="print-zones-region"></div>\n</div>';

}
return __p
};});

